// import React, { useEffect, useState } from "react";
// import PackageApi from "../../api/PackageApi";
// import AddDetails from "./AddDetails";
// import EditDetails from "./EditDetails";

// function List() {
//   const [data, setData] = useState([]);
//   const [selected, setSelected] = useState(null);

//   const fetchList = async () => {
//     const res = await PackageApi.list();
//     if (res.code === 200) {
//       setData(res.data);
//     }
//   };

//   useEffect(() => {
//     fetchList();
//   }, []);

//   const handleDelete = async () => {
//     await PackageApi.delete({ id: selected._id });
//     fetchList();
//   };

//   return (
//     <div className="content">
//       <div className="d-flex justify-content-between mb-3">
//         <h4>Project Package</h4>

//         <button
//           className="btn btn-primary"
//           data-bs-toggle="modal"
//           data-bs-target="#add-package-modal"
//         >
//           Add Package
//         </button>
//       </div>

//       <table className="table">
//         <thead>
//           <tr>
//             <th>#</th>
//             <th>Package</th>
//             <th>Modules</th>
//             <th>Action</th>
//           </tr>
//         </thead>

//         <tbody>
//           {data.map((item, index) => (
//             <tr key={item._id}>
//               <td>{index + 1}</td>
//               <td>{item.packageName}</td>

//               <td>
//                 {item.modules.map((m, i) => (
//                   <div key={i}>
//                     <b>{m.moduleName}</b> - {m.description}
//                   </div>
//                 ))}
//               </td>

//               <td>
//                 <div className="d-flex gap-2">
//                   {/* EDIT */}
//                   <button
//                     className="btn btn-soft-success btn-sm"
//                     data-bs-toggle="modal"
//                     data-bs-target="#edit-package-modal"
//                     onClick={() => setSelected(item)}
//                   >
//                     <i className="ti ti-edit"></i>
//                   </button>

//                   {/* DELETE */}
//                   <button
//                     className="btn btn-soft-danger btn-sm"
//                     data-bs-toggle="modal"
//                     data-bs-target="#delete-modal"
//                     onClick={() => setSelected(item)}
//                   >
//                     <i className="ti ti-trash"></i>
//                   </button>
//                 </div>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Add Modal */}
//       <div id="add-package-modal" className="modal fade">
//         <AddDetails onAdded={fetchList} />
//       </div>

//       {/* Edit Modal */}
//       <div id="edit-package-modal" className="modal fade">
//         <EditDetails
//           data={selected}
//           fetchList={fetchList}
//           clearSelection={() => setSelected(null)}
//         />
//       </div>

//       {/* Delete Modal */}
//       <div className="modal fade" id="delete-modal">
//         <div className="modal-dialog modal-sm">
//           <div className="modal-content p-3 text-center">
//             <h5>Delete?</h5>
//             <button className="btn btn-danger" onClick={handleDelete}>
//               Yes
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default List;

import React, { useEffect, useState } from "react";
import PackageApi from "../../api/PackageApi";
import AddDetails from "./AddDetails";
import EditDetails from "./EditDetails";

import { useNavigate } from "react-router-dom";

function List() {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const fetchList = async () => {
    const res = await PackageApi.list();

    if (res.code === 200) {
      setData(res.data);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handleDelete = async () => {
    await PackageApi.delete({ id: selected._id });
    fetchList();
  };

  return (
    <div className="content modern-package-page">
      {/* ================= HEADER ================= */}

      <div className="package-topbar">
        <div className="package-heading-wrap">
          <div className="package-heading-badge">
            <i className="ti ti-box"></i>
            Package Management
          </div>

          <h2 className="package-title">Project Packages</h2>

          <p className="package-subtitle">
            Create, manage and organize your project packages with a clean and
            powerful workflow.
          </p>

          <div className="package-heading-line"></div>
        </div>

        <button
          className="btn package-add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add-package-modal"
        >
          <i className="ti ti-plus me-2"></i>
          Add Package
        </button>
      </div>

      {/* ================= SEARCH + FILTER ================= */}

      <div className="package-toolbar">
        <div className="package-search">
          <i className="ti ti-search"></i>

          <input type="text" placeholder="Search packages..." />
        </div>

        {/* <div className="package-view-btns">
          <button className="active">
            <i className="ti ti-layout-list"></i>
          </button>

          <button>
            <i className="ti ti-layout-grid"></i>
          </button>
        </div> */}
      </div>

      {/* ================= PACKAGE LIST ================= */}

      <div className="package-list-wrap">
        {data.map((item, index) => (
          <div className="package-card" key={item._id}>
            {/* LEFT NUMBER */}

            <div className="package-number">
              {(index + 1).toString().padStart(2, "0")}
            </div>

            {/* ICON */}

            <div className="package-icon">
              <i className="ti ti-box"></i>
            </div>

            {/* CONTENT */}

            <div className="package-content">
              <div className="package-left">
                <h4>{item.packageName}</h4>

                <div className="package-meta">
                  <span className="active-badge">
                    <span className="dot"></span>
                    Active
                  </span>

                  <span>
                    <i className="ti ti-stack-2"></i>
                    {item.modules?.length || 0} Modules
                  </span>
                </div>
              </div>

              {/* MODULES */}

              <div className="package-modules">
                <h6>Modules Included</h6>

                <div className="module-tags">
                  {item.modules.map((m, i) => (
                    <span className="module-chip" key={i}>
                      {m.moduleName}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* ACTIONS */}

            <div className="package-actions">
              {/* VIEW */}

              <button
                className="action-btn view-btn"
                onClick={() => navigate(`/project-package/view/${item._id}`)}
              >
                <i className="ti ti-eye"></i>
              </button>

              {/* EDIT */}

              <button
                className="action-btn edit-btn"
                data-bs-toggle="modal"
                data-bs-target="#edit-package-modal"
                onClick={() => setSelected(item)}
              >
                <i className="ti ti-edit"></i>
              </button>

              {/* DELETE */}

              <button
                className="action-btn delete-btn"
                data-bs-toggle="modal"
                data-bs-target="#delete-modal"
                onClick={() => setSelected(item)}
              >
                <i className="ti ti-trash"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ================= ADD MODAL ================= */}

      <div id="add-package-modal" className="modal fade">
        <AddDetails onAdded={fetchList} />
      </div>

      {/* ================= EDIT MODAL ================= */}

      <div id="edit-package-modal" className="modal fade">
        <EditDetails
          data={selected}
          fetchList={fetchList}
          clearSelection={() => setSelected(null)}
        />
      </div>

      {/* ================= DELETE MODAL ================= */}

      {/* ================= DELETE MODAL ================= */}

      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="delete-icon">
              <i className="ti ti-trash"></i>
            </div>

            <h4>Delete Package?</h4>

            <p>This action cannot be undone.</p>

            <div className="delete-modal-actions">
              <button
                className="btn w-100 delete-cancel-btn"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                className="btn w-100 delete-confirm-btn"
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default List;
